export default "__VITE_ASSET__rYORuynt__"